import axios from 'axios';
import './serviceBase.interceptor'
import { GetHeaderWithToken } from '../../resources/Utils'

axios.defaults.withCredentials = true

function ServiceBase() {
  this.get = (api, params, headers) => {
    return axios.get(api, GetHeaderWithToken(headers));
  }
  this.post = (api, params, headers) => {
    const config = GetHeaderWithToken(headers);
    if (typeof FormData !== 'undefined' && params instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return axios.post(api, params, config);
  }
  this.put = (api, params) => {
    const config = GetHeaderWithToken();
    if (typeof FormData !== 'undefined' && params instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return axios.post(api, params, config);
  }
  this.delete = (api, params, headers) => {
    if(params)
      return axios.delete(api, params, GetHeaderWithToken(headers));
    else
      return axios.delete(api, GetHeaderWithToken());
  }
}
const serviceBase = new ServiceBase();

export default serviceBase;
